export enum SearchTermStitchSearchTermByTermBenchmarkHistoricalGrowthMetrics {
  COUNT_SEARCH = 'COUNT_SEARCH',
  COUNT_SEARCH_PCT_DIFF = 'COUNT_SEARCH_PCT_DIFF',
  SEARCH_CONVERSION = 'SEARCH_CONVERSION',
  SEARCH_CONVERSION_PCT_DIFF = 'SEARCH_CONVERSION_PCT_DIFF',
  COUNT_NULL_SEARCH = 'COUNT_NULL_SEARCH',
  COUNT_CONVERTED_SEARCH = 'COUNT_CONVERTED_SEARCH',
  COUNT_UNCONVERTED_SEARCH = 'COUNT_UNCONVERTED_SEARCH',
  BENCHMARK_SEARCH_CONVERSION = 'BENCHMARK_SEARCH_CONVERSION',
  DIFF_SEARCH_CONVERSION_TERM_BENCHMARK = 'DIFF_SEARCH_CONVERSION_TERM_BENCHMARK',
  SEARCH_CONVERSION_TERM_BENCHMARK_CONVERSION_GAP = 'SEARCH_CONVERSION_TERM_BENCHMARK_CONVERSION_GAP',
}

export enum SearchTermStitchSearchTermByTermBenchmarkHistoricalGrowthGroupBys {
  DATE_PT = 'DATE_PT',
  WEEK_SAT_PT = 'WEEK_SAT_PT',
  WEEK_SUN_PT = 'WEEK_SUN_PT',
  WEEK_MON_PT = 'WEEK_MON_PT',
  MONTH_PT = 'MONTH_PT',
  ORDER_SOURCE = 'ORDER_SOURCE',
  SEARCH_TERM = 'SEARCH_TERM',
}
